module.exports = __webpack_public_path__ + "media/images/icons/activity-complete-icon-13e1a289a4a6a342ee430f97dd8f2b5a.svg";